import React from 'react';
import { FadeIn } from '../ui/FadeIn';
const PAIN_POINTS = [{
  emoji: '🫧',
  title: 'The Bubble Struggle',
  desc: 'My resin keeps coming out with bubbles no matter what I try'
}, {
  emoji: '😤',
  title: 'The Sticky Mess',
  desc: 'I followed the tutorial perfectly and it still went sticky'
}, {
  emoji: '💸',
  title: 'Wasted Money',
  desc: "I've spent hundreds on supplies and have nothing to show for it"
}, {
  emoji: '😔',
  title: 'Feeling Left Behind',
  desc: "Everyone else makes it look so easy. Why can't I do it?"
}, {
  emoji: '🎲',
  title: 'The Pour Lottery',
  desc: "Every pour feels like a lottery — I never know if it'll work"
}, {
  emoji: '📱',
  title: 'Tutorial Overload',
  desc: "I've watched hours of YouTube and I'm more confused than ever"
}];
export function PainPoints() {
  return <section className="w-full px-4 md:px-8 max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-171">
      <FadeIn data-id="element-172">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-173">
          Sound Familiar?
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-174">
          You're not alone.
        </h2>
        <p className="font-lato text-lg text-cream/80 max-w-2xl mx-auto mb-16" data-id="element-175">
          This is exactly what our students felt before they found this system:
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mb-10" data-id="element-176">
        {PAIN_POINTS.map((point, index) => <FadeIn key={index} delay={index * 100} direction="up" data-id="element-177">
            <div className="bg-darkCard border border-darkBorder rounded-xl p-6 md:p-8 text-left transition-all duration-300 hover:-translate-y-1 hover:border-amber/50 group" data-id="element-178">
              <div className="w-full flex items-center justify-center rounded-lg mb-5 py-4" style={{
            backgroundColor: 'rgba(192, 155, 94, 0.06)'
          }} data-id="element-179">
                <span className="text-5xl md:text-6xl" aria-hidden="true" data-id="element-180">
                  {point.emoji}
                </span>
              </div>
              <div data-id="element-181">
                <h3 className="font-lato font-bold text-cream text-lg mb-2 group-hover:text-amber transition-colors" data-id="element-182">
                  {point.title}
                </h3>
                <p className="font-lato text-cream/70 leading-relaxed" data-id="element-183">
                  "{point.desc}"
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={150} className="w-full mb-10" data-id="element-184">
        <img src="https://cdn.magicpatterns.com/uploads/6Uz2G8MQYFaY7QsffxD9Sw/BEFORE.jpg" alt="Failed resin piece with bubbles, sticky texture, and ruined mold" className="w-full max-w-lg mx-auto aspect-[4/3] object-cover rounded-lg" data-id="element-185" />
        <p className="italic text-sm text-cream/50 text-center mt-3 font-lato" data-id="element-186">
          Sound familiar? This is what happens without a system.
        </p>
      </FadeIn>

      <FadeIn delay={200} className="w-full max-w-3xl" data-id="element-187">
        <div className="bg-darkCard border-l-4 border-amber p-6 md:p-8 rounded-r-xl shadow-lg relative overflow-hidden" data-id="element-188">
          <div className="absolute top-0 right-0 text-amber/5 text-9xl font-playfair leading-none -mt-4 -mr-4 select-none pointer-events-none" data-id="element-189">
            "
          </div>
          <p className="font-playfair italic text-xl md:text-2xl text-cream/90 relative z-10 mb-4" data-id="element-190">
            "There has to be a right way to do this. I just need someone to
            explain it properly."
          </p>
          <p className="font-lato text-amber/80 text-sm uppercase tracking-wider font-bold" data-id="element-191">
            — Real words from our students
          </p>
        </div>
      </FadeIn>
    </section>;
}